"use client"

import {
  GREETING_BANNER_HERO_IMAGE_CLASS,
  GREETING_BANNER_HERO_IMAGE_STYLE,
  GREETING_BANNER_HERO_SLOT_CLASS,
  GREETING_BANNER_HERO_SLOT_STYLE,
  GREETING_BANNER_HERO_WRAPPER_CLASS,
} from "@/lib/greeting-banner-illustrations"

/** Figma `banner` slot (344:995) — positioned crop window, not full bleed. */
export function GreetingBannerHeroIllustration({ src }: { src: string }) {
  return (
    <div aria-hidden className={GREETING_BANNER_HERO_WRAPPER_CLASS}>
      <div className={GREETING_BANNER_HERO_SLOT_CLASS} style={GREETING_BANNER_HERO_SLOT_STYLE}>
        <img
          src={src}
          alt=""
          className={GREETING_BANNER_HERO_IMAGE_CLASS}
          style={GREETING_BANNER_HERO_IMAGE_STYLE}
        />
      </div>
    </div>
  )
}
